<template>
	<div>
		<!-- <divBox1 :title="'储能信息'"></divBox1> -->
        <title1 title="储能信息" subTitle="Energy Storage Information" />
		<div class="main-box-chunengxinxi">
			<div class="main-box-left">
				<div class="top">
					<div class="img" :class="{'beijing': channel == 'beijing'}">
						<div class="number DS-Digital-Bold">
							{{ storedEnergy.residue_elect || 0 }}%
						</div>
						<img src="~@/assets/images/exposition/chucunshengyudianliang.png" alt="">
					</div>
				</div> 
				<div class="bottom">
					储能剩余电量
				</div>
			</div>
			<div class="main-box-right">
				<div class="main-box-right-cell">
					<div class="top DS-Digital-Bold">{{ storedEnergy.daily_earnings  }}</div>
					<div class="bottom">{{ now }}累计收益(元)</div>
				</div>
				<div class="main-box-right-cell">
					<div class="top DS-Digital-Bold">{{ parseFloat(storedEnergy.daily_efficiency || 0).toFixed(2)  }}</div>
					<div class="bottom">{{ now }}充放电效率(%)</div>
				</div>
				<div class="main-box-right-cell">
					<div class="top DS-Digital-Bold">{{ storedEnergy.input_elect  }}</div>
					<div class="bottom">{{ now }}充电量(kWh)</div>
				</div>
				<div class="main-box-right-cell">
					<div class="top DS-Digital-Bold">{{ storedEnergy.output_elect  }}</div>
					<div class="bottom">{{ now }}放电量(kWh)</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import divBox1 from '@/views/mobile/components/divBox1'
  import title1 from '@/views/exposition/components/title1'
  import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	export default{
		components: {
			divBox1,
      title1
		},
    data() {
      return {
        storedEnergy: {},
        now: '日',
		channel: localStorage.getItem('bigScreen::channel')
      }
    },

    destroyed() {
				// this.$bus.$off('onfangdiangonglv')
			},
    mounted(){
      this.$bus.$on('onfangdiangonglv', ()=>{
					this.getstoredEnergy()
				})
      this.getstoredEnergy()
    },
    methods: {
        getstoredEnergy() {
          if(!localStorage.getItem('typeTime')){
        console.log(localStorage.getItem('typeTime'), '111')
        this.now = '日'
      }else{
        console.log(localStorage.getItem('typeTime'), '222')
        this.now = localStorage.getItem('typeTime')
      }
	  const now = new Date();
	  const year = now.getFullYear();
	  const month = (now.getMonth() + 1).toString().padStart(2, "0");
	  const day = now.getDate().toString().padStart(2, "0");
	  const timer = `${year}-${month}-${day}`
	  
          let params = {
            "enCode": "snec-left-chunengxinxi",
			"@dim_date": localStorage.getItem("changeDataNuber") || timer,
            "@harbour_id": localStorage.getItem("harbour_id") || '76df7579ccc24d2693f6488c38a3a0b0',
          }
          dataInterface.dataFaceApi(params).then((res) => {
            console.log(res, '储能信息')
            this.storedEnergy = res[0] || {}
          }).catch((err) => {
            console.log(err);
          });
        }
    }
	}
</script>

<style lang="scss" scope>
	.main-box-chunengxinxi{
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: 25px;
		.main-box-left{
			width: 140px;
			.img{
				width: 140px;
				height: 140px;
				position: relative;
				margin-top: 20px;
				&.beijing {
					height: 120px;
				}
				.number{
					font-size: 26px;
					position: absolute;
					width: 140px;
					height: 30px;
					top: 50%;
					transform: translate(0, -50%);
					text-align: center;
				}
				img{
					width: 100%;
					height: 100%;
				}
			}
			.bottom{
				text-align: center;
				height: 60px;
				line-height: 80px;
				font-size: 20px;
			}
		}
		.main-box-right{
			flex: 1;
			padding: 20px 0;
			padding-left: 30px;
			display: flex;
			flex-wrap: wrap;
			.main-box-right-cell{
				width: 130px;
				height: 100px;
				.top{
					height: 30px;
					// padding: 10px 0px;
					line-height: 30px;
					font-size: 26px;
					color: #02b9bd;
				}
				.bottom{
					height: 30px;
					padding: 10px 0px;
					line-height: 30px;
					font-size: 18px;
				}
			}
		}
	}
</style>